var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header mb-md-5"},[_c('iframe',{attrs:{"id":"header","src":_vm.standaloneHeaderUrl,"width":"100%","height":"58px","seamless":"seamless","frameborder":"0","scrolling":"no"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }